export const LanguageOptions = [
  {
    id: 63,
    name: "JavaScript",
    label: "JavaScript",
    value: "javascript",
  },
  {
    id: 64,
    name: "Typescript",
    label: "Typescript",
    value: "Typescript",
  },
  {
    id: 65,
    name: "html",
    label: "Html",
    value: "html",
  },
  {
    id: 66,
    name: "css",
    label: "Css",
    value: "css",
  },
  {
    id: 67,
    name: "scss",
    label: "Scss",
    value: "scss",
  },
  {
    id: 68,
    name: "C ",
    label: "C ",
    value: "C",
  },
  {
    id: 69,
    name: "java",
    label: "Java",
    value: "java",
  },
  {
    id: 70,
    name: "php",
    label: "Php",
    value: "php",
  },
  {
    id: 71,
    name: "json",
    label: "Json",
    value: "json",
  },
  {
    id: 72,
    name: "C++ ",
    label: "C++ ",
    value: "C++",
  },
  {
    id: 73,
    name: "Pug",
    label: "Pug ",
    value: "Pug",
  },
  {
    id: 74,
    name: "Python",
    label: "Python ",
    value: "Python",
  },
];
